import React from 'react';
import {LoadingPage} from 'components/loading-page';
import {Demands, User} from 'api';
import {toastr} from 'react-redux-toastr';
import {withRouter, Link} from 'react-router-dom';
import {DateTime} from 'components/UI/DateTime';
import {ShowIf} from 'components/utils';
import './_MyDemandDetailContent.scss';
import {DemandConversationsContainer} from 'components/demand';

class MyDemandDetailContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  render() {
    const {content, createdAt, phone} = this.props;
    return (
      <section className='need-offer-container need-offer-list-business-container mb35'>
        <h2 className='need-offer-title'>Chi tiết nhu cầu</h2>
        <div className="my-demand-detail">
          <div className='wrap-content-need-offer'>
            <p className='need-offer-content-black'>Nội dung:</p>
            <p className='need-offer-content'>{content}</p>
          </div>
          <div className='need-offer-content-time-wrap'>
            <span className='need-offer-content-black'>Thời gian:</span>
            <span className='need-offer-content'><DateTime dateTime={createdAt}/></span>
          </div>
          <ShowIf condition={phone}>
            <div className='wrap-content-need-offer'>
              <span className='need-offer-phone-black'>Số điện thoại:</span>
              <span className='need-offer-phone'>{phone}</span>
            </div>
          </ShowIf>
          <div className='need-offer-content-category-wrap'>
            <span className='need-offer-content-black mr5'>Nhóm sản phẩm:</span>
            {
              this.props.categories.map((category, idx) => {
                return (
                  <span className='category'>
                    <Link className="category-demand" to={`/list-products/${category.id}`} target="_blank">{category.name}</Link>
                    <ShowIf condition={this.props.categories.length > idx + 1}>
                      <span> / </span>
                    </ShowIf>
                  </span>
                );
              })
            }
          </div>
        </div>

        <DemandConversationsContainer demand={this.props}/>
      </section>
    );
  }
}

export default withRouter(MyDemandDetailContent);



// WEBPACK FOOTER //
// ./components/users/my-demand-content/MyDemandDetailContent.jsx